React = require 'react'
{ PropTypes } = React
SelectThing = require '../components/SelectThing'

SelectDistrict = React.createClass
	displayName: 'SelectDistrict'
	propTypes:
		disabled: PropTypes.bool
		districts: PropTypes.array
		feedback: PropTypes.object
		isFetching: PropTypes.bool
		reduxFormProps: PropTypes.object
		selectedDistrictId: PropTypes.number
		# If `selectDistrict` isn't supplied, SelectThing will attempt to use `reduxFormProps.onChange()`
		selectDistrict: PropTypes.func
		useLocalStorage: PropTypes.bool

	render: ->
		React.createElement(SelectThing, { \
			"disabled": ( @props.disabled ),  \
			"feedback": ( @props.feedback ),  \
			"isFetching": ( @props.isFetching ),  \
			"nameField": 'name',  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"selectedThingId": ( @props.selectedDistrictId ),  \
			"selectThing": ( @props.selectDistrict ),  \
			"thingName": ( 'district' ),  \
			"things": ( @props.districts ),  \
			"useLocalStorage": ( @props.useLocalStorage )
		})

module.exports = SelectDistrict



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/components/SelectDistrict.cjsx